import axios from 'axios'

const API_BASE_URL = 'https://erp.intrare.app'
const API_KEY = 'intrare_PpDmhOSqc8fgDcFFEPVfKIK6KH7PWo26lMd4C-VlI04'

class TicketsService {
  constructor() {
    this.apiUrl = `${API_BASE_URL}/api`
  }

  getAuthHeaders() {
    return {
      'X-API-Key': API_KEY,
      'Content-Type': 'application/json'
    }
  }

  async getAreas() {
    try {
      const response = await axios.get(
        `${this.apiUrl}/areas`,
        { headers: this.getAuthHeaders() }
      )
      return {
        success: true,
        data: response.data.data
      }
    } catch (error) {
      console.error('Error obteniendo áreas:', error)
      return {
        success: false,
        error: error.response && error.response.data ? error.response.data.message : error.message
      }
    }
  }

  async getTicketsByEmail(email, limit = 50) {
    try {
      const response = await axios.get(
        `${this.apiUrl}/tickets?email=${encodeURIComponent(email)}&limit=${limit}`,
        { headers: this.getAuthHeaders() }
      )
      return {
        success: true,
        data: response.data.data
      }
    } catch (error) {
      console.error('Error obteniendo tickets:', error)
      return {
        success: false,
        error: error.response && error.response.data ? error.response.data.message : error.message
      }
    }
  }

  async getTicketById(ticketId) {
    try {
      const response = await axios.get(
        `${this.apiUrl}/ticket/${ticketId}`,
        { headers: this.getAuthHeaders() }
      )
      return {
        success: true,
        data: response.data.data
      }
    } catch (error) {
      console.error('Error obteniendo ticket:', error)
      return {
        success: false,
        error: error.response && error.response.data ? error.response.data.message : error.message
      }
    }
  }

  async createTicket(ticketData) {
    const response = await axios.post(
      `${this.apiUrl}/tickets`,
      ticketData,
      { headers: this.getAuthHeaders() }
    )
    return {
      success: true,
      data: response.data.data
    }
  }
}

export const ticketsService = new TicketsService()
